var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"nav-link btn btn-outline-secondary btn-sm mx-md-3",on:{"click":_vm.turnInstructor}},[_vm._v("Virar Instrutor")])])}
var staticRenderFns = []

export { render, staticRenderFns }